export default "__VITE_PUBLIC_ASSET__f4670d2c__"